import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';

/**
 * Proto Language DTO
 */
export class ProtoLanguageDto extends BaseProtoDto {
	/**
	 * Language name
	 */
	name!: string;

	/**
	 * ISO 639-1 language code
	 */
	isoCode!: string;

	/**
	 * Flag indicating whether this language is in use
	 */
	isVisible!: boolean;
}
